import { CHAT_STATUS_MAP } from 'constants/index';
import actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
  chatToken: '',
  initializationData: {},
  associateStatus: CHAT_STATUS_MAP.UNKNOWN,
};

export const chat = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.INITIALIZE_CHAT_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.INITIALIZE_CHAT_SUCCESS:
      return {
        ...state,
        loading: false,
        initializationData: payload,
      };
    case actionTypes.INITIALIZE_CHAT_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.GET_CHAT_TOKEN_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_CHAT_TOKEN_SUCCESS:
      return {
        ...state,
        chatToken: payload,
        loading: false,
      };
    case actionTypes.GET_CHAT_TOKEN_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case actionTypes.SET_ASSOCIATE_CHAT_STATUS:
      return {
        ...state,
        associateStatus: payload,
      };
    case actionTypes.CLEAR_CHAT_INITIALIZATION_DATA:
      return {
        ...state,
        initializationData: {},
      };

    default:
      return state;
  }
};

export default chat;
